module.exports = __webpack_public_path__ + "assets/images/app-logo-157c06cff6c80227eb577f35c79e58b6.png";